import React from 'react';
import PropTypes from 'prop-types';
import RichText from '../rich-text/base';
import { useLayout } from '../layout/context';
import { StyledGraph } from './styles';
import { TwoThirds } from '../styled/containers';
import Container from '../layout/containers/container';
import Graph from './graph';

const GraphAssembly = ({ contentfulData }) => {
  const { insideTwoThirds, insideContainer } = useLayout();

  const SummaryWrapper = insideTwoThirds ? React.Fragment : TwoThirds;
  const GraphWrapper = insideContainer ? React.Fragment : Container;
  return (
    <GraphWrapper>
      <StyledGraph>
        <Graph
          title={contentfulData.title}
          xAxisLabel={contentfulData.xAxisLabel}
          yAxisLabel={contentfulData.yAxisLabel}
          id={contentfulData.contentful_id}
          yAxisStart={contentfulData.yAxisStart}
          yAxisFormat={contentfulData.yAxisFormat}
          csvData={contentfulData.csvData.file.url}
          lineColors={contentfulData.lineColours}
          description={contentfulData.description}
        />
      </StyledGraph>
      <SummaryWrapper>
        <RichText richText={contentfulData.summary} />
      </SummaryWrapper>
    </GraphWrapper>
  );
};

GraphAssembly.propTypes = {
  contentfulData: PropTypes.object,
};

export default GraphAssembly;
